import { Injectable } from '@angular/core';
import {BaseApiService} from "../../common/base-api.service";
import {HttpClient} from "@angular/common/http";
import {SettingsProviderService} from "../../common/settings-provider.service";
import {Observable} from "rxjs";
import {IOptInModalInfo} from "../../message-models/optin-modal-info.interface";
import {IOptInEntry} from "../../message-models/optin-entry.interface";
import {OptInEntry} from "../../message-models/optin-entry.class";

@Injectable({
  providedIn: 'root'
})
export class TermsConditionService extends BaseApiService  {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'TermsAndCondition');
  }

  getOptInModalDetails(): Observable<IOptInModalInfo>{
    return this.get<IOptInModalInfo>('GetOptInModalDetails');
  }
  getAllOptInEntries(): Observable<IOptInEntry[]>{
    return this.get<IOptInEntry[]>('GetAllOptInEntries');
  }
  createOrUpdateOptInEntry(optInEntry: OptInEntry):Observable<IOptInEntry>{
    return this.post<IOptInEntry>("CreateOrUpdateOptInEntry", optInEntry);
  }
  UpdateOptInModalSettings(optInModalInfo: IOptInModalInfo):Observable<IOptInModalInfo>{
    return this.post<IOptInModalInfo>("UpdateOptInModalDetails", optInModalInfo);
  }
  deleteOptInEntry(optInEntry: OptInEntry):Observable<boolean>{
    return this.post<boolean>("DeleteOptInEntry", optInEntry);
  }
  clearAllCompanyOptInEntries(optInEntry: OptInEntry):Observable<boolean>{
    return this.post<boolean>("ClearAllCompanyOptInEntries", optInEntry);
  }
}
